module.exports = __webpack_public_path__ + "img/Fb-reservation-tw.ba3d1a58.png";